/**
 * globaler reservierter Drag
 */
const _drag = {
    owner: null,
    dragstreamId: -1,
    globalDragstreamId: 0,
}

/**
 * globales Beenden des Dragvorganges
 */
$(window).on('mouseup touchend',function(){
    _.defer(()=>{
        _drag.globalDragstreamId++;
    });
});

/**
 * Falls mehrere Drag-Listener parallel auf einem Element lauschen, kann hiermit ein einzelner Listener alle anderen
 * für den Rest des Dragvorganges inaktivieren oder sich selbst sperren. Das ist praktisch,
 * weil sich erst während der Bewegung ergeben kann, welcher Listener zuständig ist.
 * Wird bei der Scrollarea und dem DragDropHandler3D verwendert, damit zwischen Scrollbewegung und DragDrop
 * unterschieden werden kann und der Code beider Klassen entkoppelt bleibt.
 */
export default class Dragswitch {

    /**
     * das Element, auf dem gelauscht wird
     */
    constructor(element,name) {
        if (element?.length==0) {
            console.warn('Dragswitch called with no element');
            // debugger;
        }
        this.element = element;
        this.unclaimedDragstreamId = -1;
        this.name = name;
    }

    /**
     * beansprucht alle Callbackaufrufe für sich. Andere Listener erhalten von da an keine Events mehr.
     */
    claimDragStream() {
        _drag.owner = this;
        _drag.dragstreamId = _drag.globalDragstreamId;
        this.unclaimedDragstreamId = -1;
    }

    /**
     * macht claimDragStream rückgängig. Andere Listener erhalten von da an wieder Events.
     */
    freeDragStream() {
        if (this.claimed()) {
            _drag.dragstreamId = -1;
            _drag.owner = null;
        }
    }

    /**
     * Sperrt sich selbst von weiteren Events aus und gibt DragStream für andere frei, falls er von hier geclaimed war.
     */
    unclaimDragStream() {
        this.freeDragStream();
        this.unclaimedDragstreamId = _drag.globalDragstreamId;
    }

    /**
     * registriert ein Callback für ein Event. Das Callback wird aber nur aufgerufen, wenn
     * claimDragStream klappt nur für Callbacks, die über diese Methode registriert werden
     * @returns cleanup, welche den listener wegräumt
     */
    on(eventname,callback) {
        const this_ = this;
        function fn() {
            // console.log(this_.name,eventname,{active:this_.active(),claimed:this_.claimed()});
            if (this_.active()) {
                callback.apply(this,arguments);
            }
        }
        this.element.on(eventname, fn);
        return ()=>this.element.off(eventname,fn);
    }

    off(eventname,callback) {
        this.element.off(eventname,callback);
    }

    /** */
    getStreamId() {
        return _drag.globalDragstreamId;
    }

    /**
     * hat diese Dragswitch-Instanz die Callbackaufrufe für sich beansprucht?
     */
    claimed() {
        return this.unclaimedDragstreamId!==_drag.globalDragstreamId && _drag.globalDragstreamId===_drag.dragstreamId && _drag.owner===this;
    }

    /**
     * hat oder hatte diese Dragswitch-Instanz die Callbackaufrufe für sich beansprucht
     */
    active() {
        return this.unclaimedDragstreamId!==_drag.globalDragstreamId && (_drag.globalDragstreamId!==_drag.dragstreamId || _drag.owner===this);
    }

}
